/**
 * @name api/postal.js
 * @module app
 * 
 * @description 
 * Mocking client-server processing
 * 
 * @project spotgig4app
 * @author Ryunosuke Oguri on 2018/05/21
 * Copyright © 2017年 Axis-motion. All rights reserved.
 */

import API from '../api'
// const API_URI = '/api/v1/postals'
const API_URI = '/v1/postals'


export default {
  // getAddress (params, callback) {
  //   return API.get(API_URI + '/address', params, callback)
  // },
  search (params) {
    return API.request('get', API_URI + '/search', params)
  },
 
}